<template>
  <div class="container landing" v-if="!gameStarted && !showDonationScreen">
    <div class="row top">
      <img src="images/title.svg" alt="Truth or Juicy title image" class="responsive-img title-image">
    </div>
    <div class="row bottom">
      <button class="play-button" @click="startGame" :disabled="loadingQuestions"
        :class="{ disabled: loadingQuestions }">
        <img src="images/play_button.webp" alt="play button" width="130" height="172" class="responsive-img">
      </button>
      <p class="loading-text" v-if="loadingQuestions">Loading...</p>
      <label class="adult-toggle" @click.prevent="toggleAdultQuestions">
        <span class="adult-toggle-text">Include adult questions</span>
        <input type="checkbox" v-model="omitAdultQuestions" style="display: none;" />
        <div class="toggle-slider" :class="{ 'enabled': !omitAdultQuestionsValue }"></div>
      </label>
    </div>
  </div>
</template>

<script>
import { useStore } from '../store';
import { mapState, mapActions } from 'pinia';

export default {
  computed: {
    ...mapState(useStore, ['gameStarted', 'showDonationScreen', 'loadingQuestions']),
    omitAdultQuestions: {
      get() {
        return useStore().omitAdultQuestions;
      },
      set(value) {
        useStore().omitAdultQuestions = value;
      },
    },
    omitAdultQuestionsValue() {
        return useStore().omitAdultQuestions;
    }
  },
  methods: {
    ...mapActions(useStore, ['startGame', 'toggleAdultQuestions']),
  },
};
</script>

<style scoped>
.landing {
    z-index: 1;
}

.landing::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: linear-gradient(135deg, #FFE066, #FFCC5C);
    z-index: -1;
}

body.dark-mode .landing::before {
    background: var(--background-dark);
}

.play-button {
    background-color: transparent;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #f89839;
    font-size: 24px;
    padding: 10px;
    margin: 120px 0;
    position: absolute;
    top: 0;
    flex-direction: row;
}

.loading-text {
    background-color: transparent;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--raspberry-pink);
    font-size: 24px;
    padding: 10px;
    margin: 20px 0;
    position: absolute;
    bottom: 20%;
    flex-direction: row;
}

.adult-toggle {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    gap: 15px;
    margin-top: 320px;
    cursor: pointer;
    transition: transform 0.2s ease;
}

.adult-toggle:active {
    transform: scale(0.95);
}

.adult-toggle .toggle-slider {
    margin-left: 0;
    width: 40px;
    height: 20px;
    background-color: #e0b7a0; /* Lighter, muted/greyish version of coral */
    position: relative;
    border-radius: 34px;
    transition: background-color 0.2s ease;
}

.adult-toggle .toggle-slider:before {
    content: "";
    position: absolute;
    height: 16px;
    width: 16px;
    left: 2px;
    bottom: 2px;
    background-color: #fff;
    border-radius: 50%;
    transition: transform 0.2s ease;
}

.adult-toggle .toggle-slider.enabled {
    background-color: var(--raspberry-pink);
}

.adult-toggle .toggle-slider.enabled:before {
    transform: translateX(20px);
}

.adult-toggle .toggle-slider {
    order: -1;
}

.title-image {
    margin-top: 45vh;
}

.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
}

.container {
    display: flex;
    flex-direction: column;
    width: 100vw;
    height: 100vh;
}

.row {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 50%;
}

.top {
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
}

.bottom {
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: relative;
}

.responsive-img {
    max-width: 100%;
    height: auto;
}
</style>
